import { sumBy, uniqBy } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';

import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';

import ModalToBody from '../../../base/ModalToBody';
import { ajaxErrorHandler } from '../../../libs/utils';
import { getCateringCosts } from '../../../services/api/cateringOptions';

class CateringCostOverviewButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      data: {
        options: [],
        claims: [],
      },
    };

    this._closeModal = this._closeModal.bind(this);
    this._openModal = this._openModal.bind(this);
  }

  static propTypes = {
    registration: PropTypes.object,
  };

  UNSAFE_componentWillMount() {
    getCateringCosts(this.props.registration.id)
      .then((response) => {
        this.setState({
          data: response,
        });
      })
      .catch(ajaxErrorHandler);
  }

  _closeModal() {
    this.setState({ showModal: false });
    document.body.classList.remove('modal-open');
  }

  _openModal() {
    this.setState({ showModal: true });
    document.body.classList.add('modal-open');
  }

  render() {
    const { showModal, data } = this.state;

    const sumNoShowAmount = data.claims.reduce((sum, day) => {
      const dayNoShowAmount = day.options.reduce((sum, option) => sum + option.penaltyAmount, 0);
      return sum + dayNoShowAmount;
    }, 0);

    const sumNoShowCost = data.claims.reduce((sum, day) => {
      const dayNoShowCost = day.options.reduce((sum, option) => sum + option.penaltyCost, 0);
      return sum + dayNoShowCost;
    }, 0);

    const uniqueClaimedOptions = uniqBy(
      data.claims.reduce((uniqueOptions, day) => {
        return uniqueOptions.concat(day.options);
      }, []),
      'name'
    );

    return (
      <>
        <Button onClick={this._openModal}>
          <Icon icon="eye" />
          <Trans>RegistrationCateringCostOverviewButton</Trans>
        </Button>

        <ModalToBody>
          <div
            className="modal fade show"
            id="m_modal_4"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1039',
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    <Trans>Catering cost estimate</Trans>
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this._closeModal}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="invoice-box">
                    <table cellPadding="0" cellSpacing="0">
                      <tbody>
                        <tr>
                          <td colSpan="5">
                            <div className="alert alert-info">
                              <Trans>CateringCostOverviewMsg</Trans>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="5" className="text-center">
                            <h5 className="m--margin-bottom-30 m--margin-top-20">
                              Used Catering <br />{' '}
                              <small className="text-muted">
                                <Trans>
                                  Catering consts until yesterday is calculated on the actual consumed amounts.
                                </Trans>
                              </small>
                            </h5>
                          </td>
                        </tr>

                        {data.claims.map((day) => [
                          <tr className="heading" key={`title${day.day}`}>
                            <td style={{ width: '40%' }}>{moment(day.day).format('dddd MMMM Do YYYY')}</td>
                            <td style={{ width: '10%' }}>
                              <Trans>Requested</Trans>
                            </td>
                            <td style={{ width: '10%' }}>
                              <Trans>Used</Trans>
                            </td>
                            <td style={{ width: '20%' }}>
                              <Trans>Price/Person</Trans>
                            </td>
                            <td style={{ width: '20%' }}>
                              <Trans>Total Price</Trans>
                            </td>
                          </tr>,
                          <tr key={`options${day.day}`}>
                            <td colSpan="5" style={{ padding: 0 }}>
                              {day.options.map((option) => (
                                <table key={day.day + option.name}>
                                  <tbody>
                                    <tr className="details">
                                      <td style={{ width: '40%' }}>{option.name}</td>
                                      <td style={{ width: '10%' }}>{option.orderedAmount}</td>
                                      <td style={{ width: '10%' }}>{option.claimedAmount}</td>
                                      <td style={{ width: '20%' }} />
                                      <td style={{ width: '20%' }}>€ {option.totalCost / 100}</td>
                                    </tr>
                                    <tr className="details details-sub">
                                      <td style={{ width: '40%' }}>Regular Price</td>
                                      <td style={{ width: '10%' }} />
                                      <td style={{ width: '10%' }}>{option.regularAmount}</td>
                                      <td style={{ width: '20%' }}>
                                        €{' '}
                                        {option.regularAmount === 0
                                          ? 0
                                          : option.regularCost / option.regularAmount / 100}
                                      </td>
                                      <td style={{ width: '20%' }}>€ {option.regularCost / 100}</td>
                                    </tr>
                                    {option.penaltyAmount > 0 && (
                                      <tr className="details details-sub">
                                        <td style={{ width: '40%' }}>No Show / Not Requested Price</td>
                                        <td style={{ width: '10%' }} />
                                        <td style={{ width: '10%' }}>{option.penaltyAmount}</td>
                                        <td style={{ width: '20%' }}>
                                          €{' '}
                                          {option.penaltyAmount === 0
                                            ? 0
                                            : option.penaltyCost / option.penaltyAmount / 100}
                                        </td>
                                        <td style={{ width: '20%' }}>€ {option.penaltyCost / 100}</td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              ))}
                            </td>
                          </tr>,
                          <tr className="details day-total" key={`total${day.day}`}>
                            <td style={{ width: '40%' }}>Total</td>
                            <td />
                            <td />
                            <td />
                            <td>€ {day.totalCost / 100}</td>
                          </tr>,
                        ])}

                        <tr className="total">
                          <td colSpan="3" />

                          <td colSpan="2">€ {data.totalClaimsCost / 100}</td>
                        </tr>

                        {!!data.options.length && (
                          <React.Fragment>
                            <tr>
                              <td colSpan="5" className="text-center">
                                <h5 className="m--margin-bottom-30 m--margin-top-20">
                                  Planned Catering Estimated Costs
                                  <br />{' '}
                                  <small className="text-muted">
                                    <Trans>
                                      Catering for today and coming days is estimated on always consuming the requested
                                      amount
                                    </Trans>
                                  </small>
                                </h5>
                              </td>
                            </tr>

                            {data.options.map((day) => [
                              <tr className="heading" key={`title${day.day}`}>
                                <td>{moment(day.day).format('dddd MMMM Do YYYY')}</td>
                                <td>
                                  <Trans>Requested</Trans>
                                </td>
                                <td>
                                  <Trans>Used</Trans>
                                </td>
                                <td>
                                  <Trans>Price/Person</Trans>
                                </td>
                                <td>
                                  <Trans>Total Price</Trans>
                                </td>
                              </tr>,
                              <tr key={`options${day.day}`}>
                                <td colSpan="5" style={{ padding: 0 }}>
                                  {day.options.map((option) => (
                                    <table key={day.day + option.name}>
                                      <tbody>
                                        <tr className="details">
                                          <td>{option.name}</td>
                                          <td>{option.orderedAmount}</td>
                                          <td>{option.orderedAmount}</td>
                                          <td />
                                          <td>€ {option.totalCost / 100}</td>
                                        </tr>
                                        <tr className="details details-sub">
                                          <td>Regular Price</td>
                                          <td />
                                          <td>{option.orderedAmount}</td>
                                          <td>€ {option.totalCost / option.orderedAmount / 100}</td>
                                          <td>€ {option.totalCost / 100}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  ))}
                                </td>
                              </tr>,
                              <tr className="details day-total" key={`total${day.day}`}>
                                <td>Total</td>
                                <td />
                                <td />
                                <td />
                                <td>€ {day.totalCost / 100}</td>
                              </tr>,
                            ])}

                            <tr className="total">
                              <td colSpan="3" />

                              <td colSpan="2">€ {data.totalOptionsCost / 100}</td>
                            </tr>
                          </React.Fragment>
                        )}

                        <tr>
                          <td colSpan="5" className="text-center">
                            <h5 className="m--margin-bottom-30 m--margin-top-20">
                              Total: € {data.totalCost / 100} <br />{' '}
                              <small className="text-muted">
                                <Trans>Based on your used & planned catering.</Trans>
                              </small>
                            </h5>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="5" className="text-center">
                            <h5 className="m--margin-bottom-30 m--margin-top-20">
                              Total No Show / Not requested: € {sumNoShowCost / 100} <br />{' '}
                              <small className="text-muted">
                                Based on {sumNoShowAmount} no shows and not requested catering claims.
                              </small>
                            </h5>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="5" className="text-center">
                            <h5 className="m--margin-bottom-30 m--margin-top-20">
                              Catering claims summary <br /> {/*<small className="text-muted">*/}
                              {/*  Based on catering claims.*/}
                              {/*</small>*/}
                            </h5>
                          </td>
                        </tr>

                        {!uniqueClaimedOptions.length && (
                          <tr>
                            <td colSpan={5} className="text-center">
                              <em>No claims yet.</em>
                            </td>
                          </tr>
                        )}

                        {uniqueClaimedOptions.map((option) => {
                          const regularAmount = data.claims.reduce((sum, day) => {
                            return (
                              sum +
                              sumBy(
                                day.options.filter((o) => o.name === option.name),
                                'regularAmount'
                              )
                            );
                          }, 0);

                          const regularCost = data.claims.reduce((sum, day) => {
                            return (
                              sum +
                              sumBy(
                                day.options.filter((o) => o.name === option.name),
                                'regularCost'
                              )
                            );
                          }, 0);

                          const noShowAmount = data.claims.reduce((sum, day) => {
                            return (
                              sum +
                              sumBy(
                                day.options.filter((o) => o.name === option.name),
                                'penaltyAmount'
                              )
                            );
                          }, 0);

                          const noShowCost = data.claims.reduce((sum, day) => {
                            return (
                              sum +
                              sumBy(
                                day.options.filter((o) => o.name === option.name),
                                'penaltyCost'
                              )
                            );
                          }, 0);

                          return (
                            <React.Fragment>
                              <tr className="heading" key={`claimsummary${option.name}`}>
                                <td colSpan={2}>{option.name}</td>
                                <td>
                                  <Trans>Amount</Trans>
                                </td>
                                <td>
                                  <Trans>Price/Person</Trans>
                                </td>
                                <td>
                                  <Trans>Price</Trans>
                                </td>
                              </tr>
                              <tr key={`claimsummary-claims-${option.name}`} className="details">
                                <td colSpan={2}>Regular Claims</td>
                                <td>{regularAmount}</td>
                                <td>€ {regularAmount === 0 ? 0 : regularCost / regularAmount / 100}</td>
                                <td>€ {regularCost / 100}</td>
                              </tr>
                              <tr className="details mb-4" key={`claimsummary-noshows-${option.name}`}>
                                <td colSpan={2}>No shows / not requested</td>
                                <td>{noShowAmount}</td>
                                <td>€ {noShowCost ? noShowCost / noShowAmount / 100 : 0}</td>
                                <td>€ {noShowCost / 100}</td>
                              </tr>
                              <tr className="details day-total" key={`claimssummary-total-${option.name}`}>
                                <td colSpan={2}>Total</td>
                                <td>{regularAmount + noShowAmount}</td>
                                <td />
                                <td>€ {(regularCost + noShowCost) / 100}</td>
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                              </tr>
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={'modal-backdrop fade ' + (showModal ? ' show' : '')}
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1038',
            }}
            onClick={this._closeModal}
          />
        </ModalToBody>
      </>
    );
  }
}

export default CateringCostOverviewButton;
